import React from 'react';

/*
 * Certain sprites need defs to be properly displayed. This is the home for all
 * the sprite defs so they can easily be referenced from the Sprite component
 */
const defs = {
	brand: {},
	graphics: {},
	ui: {},
};

export default defs;


/** WEBPACK FOOTER **
 ** ./src/app/components/shared/spriteDefs.jsx
 **/